var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.buttonb || _vm.show_all ? _vm.showString : _vm.showString + '...')}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.runS()}}},[(_vm.descBool)?_c('b',{staticStyle:{"color":"green"}},[(!_vm.buttonb)?_c('i',{staticClass:"fa fa-plus"}):_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2231177e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Orders_v2/Aggregates/ReduceText.vue
// module id = NBL6
// module chunks = 0